export function joinErrorMessages(errors, prefixMessage) {
    var newErrors = (prefixMessage
        ? [prefixMessage].concat(errors || [])
        : errors || []).filter(function (e) { return e && e.length > 0; });
    return "" + newErrors.join('. ') + (newErrors.length > 0 ? '.' : '');
}
